import { graphql, useStaticQuery } from "gatsby";
import React, { useState } from "react";
import Gallery from "../containers/Gallery/Gallery";
import Navigation from "../containers/Navigation/Navigation";
import Snowflake from "../images/snowflake.png";
import "./styles/styles.css";

const Home = (props) => {
  const data = useStaticQuery(graphql`
    query {
      allCaramel {
        nodes {
          caramels {
            classic {
              caramel {
                color
                image
                name
                description
              }
              ingredient {
                highlights
                image
              }
            }
            anise {
              caramel {
                color
                image
                name
                description
              }
              ingredient {
                highlights
                image
              }
            }
            cocoa {
              caramel {
                color
                image
                name
                description
              }
              ingredient {
                highlights
                image
              }
            }
            dulse {
              caramel {
                color
                image
                name
                description
              }
              ingredient {
                highlights
                image
              }
            }
            lemon_poppy {
              caramel {
                color
                image
                name
                description
              }
              ingredient {
                highlights
                image
              }
            }
            rose {
              caramel {
                color
                image
                name
                description
              }
              ingredient {
                highlights
                image
              }
            }
            sesame {
              caramel {
                color
                image
                name
                description
              }
              ingredient {
                highlights
                image
              }
            }
            vegan {
              caramel {
                color
                image
                name
                description
              }
              ingredient {
                highlights
                image
                vegan
              }
            }
          }
          baseIngredients {
            main
            vegan
          }
        }
      }
    }
  `);

  const { caramels } = data.allCaramel.nodes[0];

  const [activeCaramel, setActiveCaramel] = useState("classic");

  return (
    <div className={"Main"}>
      <h1 className="Header">Happy Holidays</h1>
      <div className="Body">
        <Gallery caramels={caramels} active={activeCaramel} />
        <Navigation
          active={activeCaramel}
          caramels={caramels}
          clicked={(type) => {
            setActiveCaramel(type);
          }}
        />
      </div>
      <div className="Footer">
        <img src={Snowflake} className="Snowflake" alt="Snowflake" />
        <p>
          Wishing all of you lovely people a sweet holiday season and a
          beautiful new year.
        </p>
      </div>
    </div>
  );
};

export default Home;

export function Head() {
  return (
    <>
      <title>Holiday Caramels</title>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      {/* Preload Imperial Script font file directly - highest priority */}
      <link
        rel="preload"
        href="https://fonts.gstatic.com/s/imperialscript/v2/5DCPAKrpzy_H98IV2ISnZBbGrVNvPenlvttWNg.woff2"
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
        importance="high"
      />
      {/* Imperial Script stylesheet - prioritized */}
      <link
        rel="preload"
        as="style"
        href="https://fonts.googleapis.com/css2?family=Imperial+Script&display=swap"
        importance="high"
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Imperial+Script&display=swap"
        media="print"
        onLoad="this.media='all'"
      />
      {/* Lora font - secondary priority */}
      <link
        rel="preload"
        as="style"
        href="https://fonts.googleapis.com/css2?family=Lora&display=swap"
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Lora&display=swap"
        media="print"
        onLoad="this.media='all'"
      />
      <noscript>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Imperial+Script&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Lora&display=swap"
        />
      </noscript>
      <style>{`
        .Header {
          font-family: 'Imperial Script', cursive;
          font-display: swap;
        }
      `}</style>
    </>
  );
}
